// utils/scroll-lock-manager.ts
let configProviderEl: HTMLElement | null = null
let lockCount = 0
let scrollbarWidth: number | null = null
let originalStyles: {
  overflow: string
  paddingRight: string
} | null = null
let touchStartY = 0

// 阻止滚动传播
function preventDefault(e: Event) {
  e.preventDefault()
}

// 处理触摸事件，允许弹窗内部滚动
function handleTouchMove(e: TouchEvent) {
  // 如果是在可滚动元素内部，且内容未滚动到顶部或底部，则允许滚动
  const target = e.target as HTMLElement
  const scrollable = findScrollableParent(target)

  if (!scrollable) {
    e.preventDefault()
    return
  }

  const { scrollTop, scrollHeight, clientHeight } = scrollable
  const isAtTop = scrollTop <= 0
  const isAtBottom = scrollTop + clientHeight >= scrollHeight

  // 获取触摸移动方向
  const touch = e.touches[0]
  const deltaY = touchStartY - touch.clientY
  touchStartY = touch.clientY

  // 在顶部下拉或底部上拉时阻止滚动
  if ((isAtTop && deltaY < 0) || (isAtBottom && deltaY > 0)) {
    e.preventDefault()
  }
}

// 记录触摸起始位置
function handleTouchStart(e: TouchEvent) {
  touchStartY = e.touches[0].clientY
}

// 查找可滚动的父元素
function findScrollableParent(element: HTMLElement | null): HTMLElement | null {
  while (element && element !== document.body) {
    const { overflowY } = window.getComputedStyle(element)
    if (overflowY === 'auto' || overflowY === 'scroll') {
      return element
    }
    element = element.parentElement
  }
  return null
}

export function setAppScrollTarget(el: HTMLElement) {
  configProviderEl = el
}

function getTarget(): HTMLElement {
  return configProviderEl || document.body
}

// 计算滚动条宽度
function getScrollbarWidth(): number {
  if (scrollbarWidth !== null) return scrollbarWidth

  const outer = document.createElement('div')
  outer.style.visibility = 'hidden'
  outer.style.overflow = 'scroll'
  document.body.appendChild(outer)

  const inner = document.createElement('div')
  outer.appendChild(inner)

  scrollbarWidth = outer.offsetWidth - inner.offsetWidth
  outer.parentNode?.removeChild(outer)

  return scrollbarWidth
}

export function lockAppScroll() {
  if (lockCount === 0) {
    const el = getTarget()
    const hasScrollbar = window.innerWidth > document.documentElement.clientWidth

    // 保存原始状态
    originalStyles = {
      overflow: el.style.overflow,
      paddingRight: el.style.paddingRight,
    }

    // 设置 body 样式
    if (hasScrollbar) {
      const currentPaddingRight = parseInt(window.getComputedStyle(el).paddingRight, 10) || 0
      el.style.paddingRight = `${currentPaddingRight + getScrollbarWidth()}px`
    }

    el.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'

    // 添加事件监听器
    window.addEventListener('wheel', preventDefault, { passive: false })
    window.addEventListener('touchmove', handleTouchMove, { passive: false })
    window.addEventListener('touchstart', handleTouchStart, { passive: true })
  }
  lockCount++
}

export function unlockAppScroll() {
  lockCount--
  if (lockCount <= 0) {
    lockCount = 0
    const el = getTarget()

    if (originalStyles) {
      // 恢复原始状态
      el.style.overflow = originalStyles.overflow
      el.style.paddingRight = originalStyles.paddingRight
      document.documentElement.style.overflow = ''

      // 移除事件监听器
      window.removeEventListener('wheel', preventDefault)
      window.removeEventListener('touchmove', handleTouchMove)
      window.removeEventListener('touchstart', handleTouchStart)

      originalStyles = null
    }
  }
}
